<template>
  <div>
    <v-card>
      <v-card-actions>
        <v-spacer />
        <v-btn @click="addBadge()"> Add new badge </v-btn>
      </v-card-actions>
      <v-row v-if="$apollo.loading" align="center" justify="center">
        <v-col lg="6" md="8" sm="12">
          <v-skeleton-loader type="card, card, card" />
        </v-col>
      </v-row>
      <v-row v-else align="center" justify="center">
        <v-col lg="6" md="8" sm="12">
          <v-autocomplete
            v-model="search"
            multiple
            :items="adminBadges"
            chips
            deletable-chips
            hide-selected
            :item-value="(val) => val.id"
            :item-text="(val) => val.title"
            label="Type to find a badge"
            clearable
            background-color="navy"
            dark
            rounded
            class="pt-0"
          />
          <div>
            <v-card v-if="activeBadges && activeBadges.length == 0">
              <v-card-subtitle class="text-center"> No active {{ type }} badges to display </v-card-subtitle>
            </v-card>
            <v-card-title v-else class="secondary--text font-weight-bold font-24">
              Currently earnable {{ type }} badges
            </v-card-title>
            <badge-card
              v-for="badge in activeBadges"
              :key="badge.id"
              :badge="badge"
              :type="type"
              @edit="editBadge(badge)"
            />
          </div>
          <div class="mt-5">
            <v-card v-if="inactiveBadges && inactiveBadges.length == 0">
              <v-card-subtitle class="text-center"> No inactive {{ type }} badges to display </v-card-subtitle>
            </v-card>
            <v-card-title v-else class="secondary--text font-weight-bold font-24">
              Not currently earnable {{ type }} badges
            </v-card-title>
            <badge-card
              v-for="badge in inactiveBadges"
              :key="badge.id"
              :badge="badge"
              :type="type"
              @edit="editBadge(badge)"
            />
          </div>
        </v-col>
      </v-row>
      <v-card-actions v-if="adminBadges && adminBadges.length > 4">
        <v-spacer />
        <v-btn @click="addBadge()"> Add new badge </v-btn>
      </v-card-actions>
    </v-card>

    <badge-dialog :badgeModal="badgeModal" :type="type" :allowedDates="allowedDates" @close="badgeModal.show = false" />
  </div>
</template>

<script>
import BadgeListMixin from "./mixins/BadgeListMixin";

export default {
  name: "ConsistencyBadges",
  mixins: [BadgeListMixin],
  data() {
    return {
      type: "consistency",
      allowedDates: (val) => new Date(val).getUTCDay() === 1, // only Monday!
      badgeModal: {
        form: {
          startDate: null,
          endDate: null,
          visible: null,
          weeks: null,
        },
      },
    };
  },
  computed: {
    activeBadges() {
      return (
        this.badges?.filter(
          (badge) =>
            badge.isEnabled &&
            (badge.startDate == null || badge.startDate <= this.$moment().format("YYYY-MM-DD")) &&
            (badge.endDate == null || badge.endDate >= this.$moment().format("YYYY-MM-DD"))
        ) ?? []
      );
    },
    inactiveBadges() {
      return this.badges?.filter((badge) => !this.activeBadges.includes(badge)) ?? [];
    },
  },
  methods: {
    addBadge() {
      let form = {
        id: null,
        title: "",
        startDate: null,
        endDate: null,
        description: "",
        image: null,
        imageChanged: false,
        visible: true,
        enabled: true,
        challenge: null,
        weeks: null,
        blockChallenge: null,
        corporateChallenge: null,
        sendgridTemplateId: null,
      };

      this.badgeModal.form = form;
      this.badgeModal.show = true;
    },
    editBadge(badge) {
      let corporateChallengeId = badge.corporateChallenge?.id;
      if (corporateChallengeId != null && isNaN(corporateChallengeId)) {
        corporateChallengeId = atob(corporateChallengeId).split(":")[1];
      }

      let blockChallengeId = badge.blockChallenge?.id;
      if (blockChallengeId != null && isNaN(blockChallengeId)) {
        blockChallengeId = atob(blockChallengeId).split(":")[1];
      }

      let form = {
        id: badge.id,
        title: badge.title,
        startDate: badge.startDate,
        endDate: badge.endDate,
        description: badge.description,
        image: badge.iconLink,
        imageChanged: false,
        visible: badge.isVisible,
        enabled: badge.isEnabled,
        blockChallenge: blockChallengeId,
        corporateChallenge: corporateChallengeId,
        sendgridTemplateId: badge.sendgridTemplateId,
        weeks: JSON.parse(badge.functionValues).weeks,
      };

      this.badgeModal.form = form;
      this.badgeModal.show = true;
    },
  },
};
</script>

<style scoped>
.font-24 {
  font-size: 24px;
}
</style>
